import CustomerField from "./CustomerField";
import styles from "./customersField.module.scss";
import { Customer, ICustomer } from "../../models/Customer";
import { ForwardedRef, forwardRef, useImperativeHandle } from "react";

export interface CustomersFieldProps {
    customers: ICustomer[];
    isFormTypeUpdate: boolean;
    isCorporateMeeting: boolean;

    handleDataChange: (value: ICustomer[]) => void;
}

export interface CustomersFieldRef {
    addNew: () => void;
}

const CustomersField = forwardRef<CustomersFieldRef, CustomersFieldProps>(
    (props: CustomersFieldProps, ref: ForwardedRef<CustomersFieldRef>) => {
        const { handleDataChange } = props;

        const handleOnChange = (value: ICustomer) => {
            const index = props.customers.findIndex((customer) => customer.key === value.key);

            if (index === -1) {
                return;
            }

            props.customers[index] = value;

            handleDataChange([...props.customers]);
        };

        const handleOnDelete = (key: string) => {
            const customers = props.customers.filter((customer) => customer.key !== key);
            handleDataChange([...customers]);
        };

        const handleOnAdd = () => {
            props.customers.push(Customer.New());
            handleDataChange([...props.customers]);
        };

        const customerInputs = (
            <div className={styles.fieldsWrapper}>
                {props.customers.map((customer) => {
                    return (
                        <CustomerField
                            key={customer.key}
                            customer={customer}
                            handleDataChange={handleOnChange}
                            handleDelete={handleOnDelete}
                            isFormTypeUpdate={props.isFormTypeUpdate}
                            isCorporateMeeting={props.isCorporateMeeting}
                        />
                    );
                })}
            </div>
        );

        // Expose methods to parent using `useImperativeHandle`
        useImperativeHandle(ref, () => ({
            addNew: () => {
                handleOnAdd();
            },
        }));

        return customerInputs;
    }
);

export default CustomersField;
